<template>
    <div class="random-number">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Lower Range</div>
            <TiptapEditor
                placeholder="Lower Range"
                :show-attributes="true"
                v-model="clone.options.lowerRange"
                :show-emoji="false"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Upper Range</div>
            <TiptapEditor
                placeholder="End Number"
                :show-attributes="true"
                v-model="clone.options.upperRange"
                :show-emoji="false"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Decimal Point</div>
            <TiptapEditor
                placeholder="End Number"
                :show-attributes="true"
                v-model="clone.options.decimalPoint"
                :show-emoji="false"
                automation-mode
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("RandomNumber");
export default {
    name: "RandomNumber",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "math.random",
            values: [""],
            options: {},
        };
        clone.options = clone.options || {};
        return {
            clone,
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.random-number {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
